import TextField, { TextFieldProps } from '@mui/material/TextField';
import { createStyles, makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import classnames from 'classnames';

const useStyles = makeStyles(
  (theme: Theme) =>
    createStyles({
      input: {
        backgroundColor: theme.palette.background.paper,
      },
    }),
  {
    name: 'CatalogReactEntityAutocompletePickerInput',
  },
);

export function EntityAutocompletePickerInput(params: TextFieldProps) {
  const classes = useStyles();

  return (
    <TextField
      {...params}
      label="Tags"
      className={classnames(classes.input, params.className)}
      InputLabelProps={{ sx: { paddingLeft: '12px' } }}
      InputProps={{
        ...params.InputProps,
        sx: {
          paddingLeft: '8px',
          '&:before': {
            borderRadius: '2px',
          },
        },
      }}
    />
  );
}
